var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "22px",
    viewBox: "0 0 32 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "storing_page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOME",
    transform: "translate(-77.000000, -173.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 50,
    y: 157,
    width: 270,
    height: 732
  }), /*#__PURE__*/React.createElement("g", {
    id: "filter",
    transform: "translate(50.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8F8F8",
    x: 0,
    y: 0,
    width: 270,
    height: 55
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(24.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9157,-0.0002 L2.0847,-0.0002 C0.9337,-0.0002 -0.0003,0.9338 -0.0003,2.0838 L-0.0003,35.9158 C-0.0003,37.0668 0.9337,37.9998 2.0847,37.9998 L35.9157,37.9998 C37.0667,37.9998 37.9997,37.0668 37.9997,35.9158 L37.9997,2.0838 C37.9997,0.9338 37.0667,-0.0002 35.9157,-0.0002 M35.9157,1.9998 C35.9617,1.9998 35.9997,2.0378 35.9997,2.0838 L35.9997,35.9158 C35.9997,35.9618 35.9617,35.9998 35.9157,35.9998 L2.0847,35.9998 C2.0377,35.9998 1.9997,35.9618 1.9997,35.9158 L1.9997,2.0838 C1.9997,2.0378 2.0377,1.9998 2.0847,1.9998 L35.9157,1.9998",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2238,14.6736 C23.9428,14.6736 22.8998,13.6316 22.8998,12.3496 C22.8998,11.0686 23.9428,10.0266 25.2238,10.0266 C26.5048,10.0266 27.5478,11.0686 27.5478,12.3496 C27.5478,13.6316 26.5048,14.6736 25.2238,14.6736 L25.2238,14.6736 Z M29.4188,11.3496 C28.9648,9.4486 27.2618,8.0266 25.2238,8.0266 C23.1848,8.0266 21.4828,9.4486 21.0288,11.3496 L3.7998,11.3496 L3.7998,13.3496 L21.0288,13.3496 C21.4828,15.2516 23.1848,16.6736 25.2238,16.6736 C27.2618,16.6736 28.9648,15.2516 29.4188,13.3496 L34.1998,13.3496 L34.1998,11.3496 L29.4188,11.3496 Z",
    id: "Fill-7",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7765,27.9734 C11.4955,27.9734 10.4525,26.9314 10.4525,25.6494 C10.4525,24.3684 11.4955,23.3264 12.7765,23.3264 C14.0575,23.3264 15.0995,24.3684 15.0995,25.6494 C15.0995,26.9314 14.0575,27.9734 12.7765,27.9734 M12.7765,21.3264 C10.7375,21.3264 9.0345,22.7484 8.5805,24.6504 L3.7995,24.6504 L3.7995,26.6504 L8.5815,26.6504 C9.0355,28.5514 10.7375,29.9734 12.7765,29.9734 C14.8145,29.9734 16.5175,28.5514 16.9715,26.6504 L34.1995,26.6504 L34.1995,24.6504 L16.9715,24.6504 C16.5175,22.7484 14.8145,21.3264 12.7765,21.3264",
    id: "Fill-9",
    fill: "#979797"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.2540105b4f8adbf5dc96656d6b1391a8.svg";
export { ForwardRef as ReactComponent };